import { Component, OnInit, ViewChild } from "@angular/core";
import { MatStepper } from "@angular/material/stepper";
import { Router } from "@angular/router";
import { TrainsInfo } from "@core/models/trainsInfo";
import {
  TrainService,
} from "@core/services";
import { TranslateService } from "@ngx-translate/core";
import * as _lodash from "lodash-es";
import "moment/min/locales.min";

@Component({
  selector: "app-train-confirm-stepper-container",
  templateUrl: "./train-confirm-stepper-container.component.html",
  styleUrls: ["./train-confirm-stepper-container.component.scss"],
})
export class TrainConfirmStepperContainerComponent implements OnInit {
  @ViewChild("stepper") stepper: MatStepper;
  trainsInfo: TrainsInfo;

  constructor(
    private router: Router,
    private trainService: TrainService,
    public translate: TranslateService,
  ) {
    this.trainService.getTrainsInfo$().subscribe((info: TrainsInfo) => {
      this.trainsInfo = info;
    });
    if (this.trainsInfo === null) {
      this.router.navigate(["/train"]);
    }
  }

  ngOnInit(): void {
  }

  goBack() {
    history.back();
  }
}